import React from 'react'
import Layout from '../components/Layout'
import SubHeader from '../components/SubHeader'
import Section from '../components/Section'
import ColumnsGrid from '../components/ColumnsGrid'
import Video from '../components/Video/index'
import HuomentaaImg from '../assets/images/Huomentaa-Suomi.png'
import YrittäjäImg from '../assets/images/Yrittäjä.png'

const VideotPage = () => (
  <Layout>
    {
      <>
        <Section variant="header">
          <SubHeader heading="Videot" />
        </Section>
        <Section variant="default">
          <ColumnsGrid columns={3}>
            <Video youTubeVideoId="NSOcQT18VnI" />
            <Video
              placeholderImg={HuomentaaImg}
              videoURL="https://www.mtv.fi/sarja/huomenta-suomi-33001003008/maahanmuuttajissa-iso-osaamispotentiaali-662731"
            />
            <Video
              placeholderImg={YrittäjäImg}
              videoURL="https://www.mtv.fi/sarja/haastelahettilas-33001034001/daniel-rahman-yrittaja-666661"
            />
            <Video youTubeVideoId="Y8aXVmcCPDU" />
            <Video youTubeVideoId="hvaIOSIqaNk" />
            <Video youTubeVideoId="9AoXFChxQHc" />
            <Video youTubeVideoId="lwbn2Tn43Io" />
            <Video youTubeVideoId="HoNOF49Pb9U" />
          </ColumnsGrid>
        </Section>
      </>
    }
  </Layout>
)

export default VideotPage
